// Discover Savings data
const discoverData = {
  marketing_details: {
    pros: [
      'Access to over 60k ATMs',
      'Mobile app and checking account available',
      'Customer service available 24/7',
      'No monthly fees',
    ],
    cons: ['Limited access to physical branches'],
  },
};

// American Express Savings data
const amexData = {
  marketing_details: {
    pros: [
      'Customer service available 24/7',
      '$0 minimum balance',
      'No monthly fees',
    ],
    cons: ['No checking account, mobile app or ATM cards', 'No branches'],
  },
};

// Marcus by Goldman Sachs Savings data
const goldmanData = {
  marketing_details: {
    pros: [
      'Access to customer service 7 days/week',
      'No monthly fees',
      'Same-day transfers up to $100,000*',
    ],
  },
};

// Barclays Savings data
const barclaysData = {
  marketing_details: {
    pros: [
      'Customer service available 7 days/week',
      'Minimal non-sufficient funds fee',
      'No monthly fees',
    ],
    cons: ['No checking account, mobile app or ATM access', 'No branches'],
  },
};

// Ally Savings data
const allyData = {
  marketing_details: {
    pros: [
      'No monthly fee',
      'Rock-bottom minimum balance',
      '24/7 live customer care',
    ],
    cons: ['No physical branches'],
  },
};

// CIT Savings data
const citData = {
  marketing_details: {
    pros: [
      'Mobile app available',
      'No monthly fees',
      'Low minimum deposit for a money market account',
    ],
    cons: ['No branches or free ATM access', '$100 minimum opening balance'],
  },
};

// Synchrony Savings data
const synchronyData = {
  marketing_details: {
    pros: [
      'Access to ATMs',
      'Customer service available 7 days/week',
      '$0 minimum balance',
      'Reimburses $5 per month for out-of-network ATMs',
      'No monthly fees',
    ],
    cons: ['No checking account', 'No branches'],
  },
};

// Citizens Access Online Savings data
const citizensData = {
  marketing_details: {
    pros: [
      'No fees',
      'Customer service available 7 days/week',
      'Mobile-optimized website with a check deposit feature',
    ],
    cons: [
      'No checking account or mobile app',
      '$5,000 minimum deposit',
      'No branches',
    ],
  },
};

// HSBC Direct Savings data
const hsbcDirect = {
  marketing_details: {
    pros: ['Only $1 required to open account', 'No monthly fees'],
    cons: ['Can only be opened online'],
  },
};

// CIT Savings Builder data
const citSavings = {
  marketing_details: {
    pros: [
      'Top-notch interest rate if conditions met',
      'Customer service available 7 days/week',
      'No monthly fees',
    ],
    cons: [
      'Minimum balance of $25,000 or $100 monthly deposit required',
      'No checking account',
      'No physical branches',
    ],
  },
};

// Ally Bank
const allyBank = {
  marketing_details: {
    pros: [
      'Offers over 43,000 free ATMs',
      'Several ways to receive customer service, including by phone, email, snail mail, or live chat',
      '$0 minimum balance',
      'No monthly fees',
    ],
    cons: ['No way to deposit cash', 'No branches'],
  },
};

// Alliant Credit Union
const alliantCredit = {
  marketing_details: {
    pros: [
      'Provides more than 80,000 free ATMs',
      'Broad membership requirements, which is rare for a credit union',
      'Allows account holders to open as many as 19 supplemental accounts',
      'No monthly fees for e-statements',
    ],
    cons: [
      'No limit on number of daily overdraft charges',
      'Limited branch network',
    ],
  },
};

// Bank5 Connect
const bank5Connect = {
  marketing_details: {
    pros: ['Customer service available 7 days/week', 'ATM fee reimbursements'],
    cons: ['No branches'],
  },
};

// PurePoint
const purePoint = {
  marketing_details: {
    pros: ['Online-friendly accounts', 'No monthly fees'],
    cons: [
      '$10,000 minimum balance to gain highest saving rate',
      'No checking account or ATM access',
      'Few physical branches',
    ],
  },
};

// Discover MMA
const discoverMma = {
  marketing_details: {
    pros: ['Debit cards', 'Checks available', 'Large ATM network'],
    cons: ['Limit of six monthly debit transactions'],
  },
};

// UFB Savings
const ufbSavings = {
  marketing_details: {
    pros: ['Very competitive interest rate', '24/7 phone customer support'],
    cons: ['Large balance required to obtain highest interest rate'],
  },
};

// Vio Bank
const vioBank = {
  marketing_details: {
    pros: [
      'Very competitive savings interest rate',
      'No minimum balance required to earn interest',
      'No monthly fees for e-statements',
    ],
    cons: ['No checking account', 'No branches'],
  },
};

// SoFi Money
const sofiMoney = {
  marketing_details: {
    pros: [
      'Unlimited ATM fee reimbursements',
      'No monthly fees',
      'No overdraft fees',
    ],
    cons: ['No branches or CDs', 'No cash deposits accepted'],
  },
};

// PNC’s Virtual Wallet Account
const pncVirtualMoneyWalletAccount = {
  marketing_details: {
    pros: ['Strong sign-up bonuses', 'Good online and mobile tools'],
    cons: ['Low savings interest rate', 'High overdraft fees'],
  },
};

// Sallie Mae Savings/MMA
const sallieMaeSavingsMma = {
  marketing_details: {
    pros: [
      'Competitive savings interest rates',
      'Savings account has a $0 minimum',
    ],
    cons: ['No checking account', 'Subpar mobile app experience'],
  },
};

// TIAA Savings/MMA
const tiaaSavingsMma = {
  marketing_details: {
    pros: [
      'Low minimum required to open savings account',
      'Excellent money market account interest rates',
      'Large ATM network',
    ],
    cons: ['Small number of branches'],
  },
};

// CIBC - Savings
const cibcSavings = {
  marketing_details: {
    pros: [
      'Stellar savings account rate',
      'Strong savings tools and calculators',
      'Checking account option with no overdraft fee',
    ],
    cons: ['Relatively few branches', 'Low mobile app ratings'],
  },
};

// CIBC - CDs
const cibcCDs = {
  marketing_details: {
    pros: ['Very low early withdrawal penalty'],
    cons: [
      'You’ll need at least $1,000 to open any CIBC CD',
      'Not many branches',
    ],
  },
};

// USAA - CDs
const usaaCds = {
  marketing_details: {
    pros: [
      'Wide variety of term lengths, ranging from 1 month to 7 years',
      'Geared toward military families',
    ],
    cons: ['Minimal branch access', 'Membership limited'],
  },
};

// BMO Harris - Savings
const bmoHarrisSavings = {
  marketing_details: {
    pros: [
      'Solid interest rate on money market accounts',
      'No monthly maintenance fees',
    ],
    cons: ['Very low savings account interest rates'],
  },
};

// UFB - MMA
const ufbMma = {
  marketing_details: {
    pros: [
      'Among the highest interest rates in the industry',
      'Ability to write checks from account',
    ],
    cons: [
      '$25,000 minimum balance required for best rates',
      '$5,000 minimum balance required to avoid maintenance fees',
    ],
  },
};

// Wealthfront
const wealthfront = {
  marketing_details: {
    pros: [
      'Offers up to $1 million in FDIC coverage through affiliated partner banks',
      'Can pair with Wealthfront investment account to keep money under one roof',
      'No fees',
    ],
    cons: ['No branches', 'No mobile check deposit currently'],
  },
};

// Citibank Accelerant Savings
const citiAccelerantSavings = {
  marketing_details: {
    pros: ['No initial deposit requirement', 'Access to Citi branches'],
    cons: ['Must meet balance requirements to waive the monthly fee'],
  },
};

// Capital One 360 Performance Savings
const capitalOneSavings = {
  marketing_details: {
    pros: ['No monthly maintenance fee', 'No initial deposit requirement'],
    cons: ['Not the highest rate currently available'],
  },
};

export default {
  // Goldman Sachs
  'db221bb6-259e-11e8-9c02-0f47d65712de': goldmanData,

  // Barclays
  'e08baa9a-259e-11e8-9c02-03bb6fe04776': barclaysData,

  // Ally
  'c3224db0-259e-11e8-9c02-9f5825ad4dcf': allyData,

  // CIT
  'e09f7f84-259e-11e8-9c02-9ffd799d9b76': citData,

  // CIT MMA
  'f843ef72-2700-11e8-9c02-178aed299ad8': citData,

  // Syncrony
  'e7dbcbb8-259e-11e8-9c02-53a23c4736b6': synchronyData,

  // Discover
  'c3238d88-259e-11e8-9c02-57854a25f19b': discoverData,

  // AMEX
  'e7dabbce-259e-11e8-9c02-6ff6cb82cb54': amexData,

  // Citizens Access
  '446c8822-7e50-11e8-9c02-f356d6c4f232': citizensData,

  // HSBC Direct Savings
  'e7c0fe1e-259e-11e8-9c02-bf736f5eb8a8': hsbcDirect,

  // CIT Savings Builder
  '013693d8-c8db-11e8-9778-cb24b416a891': citSavings,

  // Ally Bank
  'aad14e1e-36b0-11e8-9c02-f7f6d00f05f1': allyBank,

  // Alliant Credit Union
  'def08cd2-259e-11e8-9c02-8f1a5992b1fb': alliantCredit,

  // Bank5 Connect
  '561da8e6-25a7-11e8-9c02-fb0c96a1f061': bank5Connect,

  // PurePoint
  'e7535c7e-259e-11e8-9c02-b33057b38981': purePoint,

  // Discover MMA
  'c324ba00-259e-11e8-9c02-33172c16ae1b': discoverMma,

  // UFB Savings
  '0dd2e852-7b39-11e8-9c02-1f02d54aa17a': ufbSavings,

  // Vio Bank
  '6e99d178-dd5e-11e8-9778-ffdfa9d8fe72': vioBank,

  // SoFi Money
  'c03ddf4e-3c84-11e9-9778-5fb67ee1ffb5': sofiMoney,

  // PNC’s Virtual Wallet Account
  '078511d8-6c4b-11e9-9778-3fdf763e8bc1': pncVirtualMoneyWalletAccount,

  // Sallie Mae Savings
  'dab2281a-259e-11e8-9c02-2301d086c748': sallieMaeSavingsMma,

  // Sallie Mae MMA
  '819198f4-347d-11e8-9c02-4fd7b0ba2665': sallieMaeSavingsMma,

  // TIAA Savings
  '8cc039d2-78b2-11e8-9c02-13e3b3af1e0d': tiaaSavingsMma,

  // TIAA MMA
  '0d9ff7a2-73f6-11e8-9c02-c35e0c3117d5': tiaaSavingsMma,

  // TIAA
  '7c9df664-6905-11e8-9c02-230c91e8b626': tiaaSavingsMma,

  // CIBC - Savings
  '5d393084-4f39-11e9-9778-bbe96378022a': cibcSavings,

  // CIBC - CDs 9mo
  'e4ce7712-a72b-11e9-a54a-e323c6143ca6': cibcCDs,

  // CIBC - CDs 12 mo
  'f8114502-a72b-11e9-a54a-83bc85e7ea0f': cibcCDs,

  // USAA CDs 12mo
  'f382a964-259e-11e8-9c02-937f7e76ff73': usaaCds,

  // USAA CDs 24mo
  'de3bdab2-259e-11e8-9c02-a366d8e4ac6e': usaaCds,

  // USAA CDs 36mo
  'ca0ff91a-259e-11e8-9c02-8ff9d5c49422': usaaCds,

  // USAA CDs 60mo
  'c6972272-259e-11e8-9c02-f35c8651b4d0': usaaCds,

  // BMO Harris - Savings
  'e7457762-259e-11e8-9c02-5b63ec89d04d': bmoHarrisSavings,

  // UFB - MMA
  '8b0206b0-48d9-11e8-9c02-3b481852466d': ufbMma,

  // Wealthfront
  'bec439aa-bade-11e9-a54a-0f3f0720e464': wealthfront,

  // Citibank Accelerant Savings
  '8af7e982-a10b-11ea-9a85-b3fff33b7cbd': citiAccelerantSavings,

  // Capital One 360 Performance Savings
  '4487dd46-e06c-11e9-ac7c-ab153cb561cb': capitalOneSavings,
};
